<template>
  <p class="ma-0 pa-0">
    {{ displayName }}
  </p>
</template>

<script>
export default {
  props: {
    tablePrefix: {
      type: String,
      default: '',
    },
    tableSuffix: {
      type: String,
      default: '卓',
    },
    tableNumber: {
      type: [String, Number],
      default: '',
    },
    customName: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayName() {
      if (this.customName) return this.customName

      return [this.tablePrefix, this.tableNumber, this.tableSuffix].join('')
    },
  },
}
</script>
